import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { DashboardComponent } from './dashboard.component';


import { PHBHPLocalizePackageModule } from 'ph-bhp-feature-packages/ph-bhp-localize-package/public_api';
import { PHBHPLayoutPackageModule } from 'ph-bhp-feature-packages/ph-bhp-layout-package/public_api';
import { PHBHPFeaturePackageEvaluationModule} from 'ph-bhp-feature-packages/ph-bhp-feature-package-evaluation/public_api';
import { PhBhpUiModule } from 'ph-bhp-feature-packages/ph-bhp-ui/src/lib/ph-bhp-ui.module';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatNativeDateModule } from '@angular/material/core';
import { MatFormFieldModule } from '@angular/material/form-field';

// common libraries


@NgModule({
  declarations: [
    DashboardComponent
  ],
  imports: [
    CommonModule,
    PHBHPLocalizePackageModule,
    PHBHPLayoutPackageModule,
    PHBHPFeaturePackageEvaluationModule,
    PhBhpUiModule,
    MatDatepickerModule, MatNativeDateModule, MatFormFieldModule
  ],
  exports: [
    //BsDatepickerModule
  ]
})
export class DashboardModule { }
